import { render, staticRenderFns } from "./right-menu.vue?vue&type=template&id=228341f3&scoped=true&"
import script from "./right-menu.vue?vue&type=script&lang=js&"
export * from "./right-menu.vue?vue&type=script&lang=js&"
import style0 from "./right-menu.vue?vue&type=style&index=0&id=228341f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228341f3",
  null
  
)

export default component.exports